import { REQUEST_URL } from "../constants";
import { RequestUtil, RequestFileUtil } from "../utils";
import { SolutionInputModel } from "../models";

export const TechnologyService = {
  getAllTechnologyPageByLanguage,
  getTechnologyPage,
  createTechnologyPage,
  uploadImageTechnologyPage,
  deleteTechnologyPage,
  updateTechnologyPage,
};

async function getAllTechnologyPageByLanguage(query: { languageId: any; categoryId: string }) {
  const url = REQUEST_URL.GET_ALL_TECHNOLOGY_PAGE_BY_LANGUAGE;

  return RequestUtil.get({ url, query });
}

async function getTechnologyPage(code: string, query?: { languageId?: string }) {
  const url = REQUEST_URL.GET_TECHNOLOGY_PAGE.replace("{CODE}", code);

  return RequestUtil.get({ url, query });
}

async function createTechnologyPage(data: SolutionInputModel[]) {
  const url = REQUEST_URL.CREATE_TECHNOLOGY_PAGE;

  return RequestUtil.post({ url, data });
}

async function uploadImageTechnologyPage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_TECHNOLOGY;

  return RequestFileUtil.post({ url, data: formData });
}

async function updateTechnologyPage(code: string, data: SolutionInputModel[]) {
  const url = REQUEST_URL.UPDATE_TECHNOLOGY_PAGE.replace("{CODE}", code);

  return RequestUtil.put({ url, data });
}

async function deleteTechnologyPage(code: string) {
  const url = REQUEST_URL.DELETE_TECHNOLOGY_PAGE.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}
